import React, { useState, useEffect, HTMLAttributes } from 'react';
import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import InlineButton from 'components/generic/InlineButton';

const defaultMaxLength = 200;
const defaultAllowedOverhang = 50;

const ExpandButton = styled(InlineButton)`
    margin-top: ${Spacing8};
`;

interface IReadMoreMaxCharactersProps extends HTMLAttributes<HTMLButtonElement> {
    children: string;
    buttonText?: string;
    maxLength?: number;
    allowedOverhang?: number;
    expand?: boolean;
    isTruncatedInitialValue?: boolean;
    onClickCallback?: () => void;
}

export const ReadMoreMaxCharacters = (props: IReadMoreMaxCharactersProps): JSX.Element => {
    const {
        children,
        buttonText,
        maxLength = defaultMaxLength,
        allowedOverhang = defaultAllowedOverhang,
        expand,
        className,
        isTruncatedInitialValue,
        onClickCallback
    } = props;

    let shortenedText: string | undefined;

    const [textTruncated, setTextTruncated] = useState(
        isTruncatedInitialValue || children.length - maxLength > allowedOverhang
    );

    if (textTruncated) {
        shortenedText = `${children.substring(0, maxLength)}...`;
    }

    const handleExpand = () => {
        setTextTruncated((prev) => !prev);

        if (onClickCallback) {
            onClickCallback();
        }
    };

    useEffect(() => {
        if (expand) {
            handleExpand();
        }
    }, [expand]);

    return (
        <>
            {shortenedText || children}
            {buttonText && textTruncated && (
                <>
                    <br />
                    <ExpandButton onClick={handleExpand} className={className}>
                        {buttonText}
                    </ExpandButton>
                </>
            )}
        </>
    );
};

export default ReadMoreMaxCharacters;
